import type { MessageBubbleProps } from './MessageBubble';

export function areMessageBubblePropsEqual(previous: MessageBubbleProps, next: MessageBubbleProps) {
  return (
    previous.canRetry === next.canRetry
    && previous.isLoading === next.isLoading
    && previous.message === next.message
    && previous.reasoningStartedAt === next.reasoningStartedAt
    && previous.showActions === next.showActions
    && (
      next.message.role !== 'user'
      || previous.onEditMessage === next.onEditMessage
    )
    && (
      (!previous.canRetry && !next.canRetry)
      || previous.onRetryAssistant === next.onRetryAssistant
    )
  );
}

